import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteMandatedProgram = (programid, usergroupid) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.GROUP_MANAGEMENT.DELETE_MANDATED_PROGRAM(
      programid,
      usergroupid
    )
  );
};

export default deleteMandatedProgram;
